import { useState } from 'react';
import { $t } from 'hooks/i18n';
import { Calendar } from 'primereact/calendar';
import { Title } from 'components/Title';

export default function SmsAlertPage() {
	
	const [pageReady, setPageReady] = useState(true);
	  const [dateFrom, setDateFrom] = useState(null); // ✅ Date | null
  const [dateTo, setDateTo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const formatDate = (d) => {
      if (!d) return "";
      const year = d.getFullYear();
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
  };
  const handleVerify = async () => {
      if (!dateFrom || !dateTo) {
          alert("Please select both dates");
          return;
      }
      setLoading(true);
      setResult(null);
      try {
          const response = await fetch(
          `${process.env.REACT_APP_API_PATH}sms/send-due-reminders`,
          {
              method: "POST",
              headers: {
                  "Content-Type": "application/json",
              },
              body: JSON.stringify({
                  fromDate: formatDate(dateFrom),
                  toDate: formatDate(dateTo)
              })
          }
          );
          const data = await response.json();
          if (!response.ok || data.success === false) {
              throw new Error(data.message || "Operation failed");
          }
          setResult(data);
          } catch (error) {
          console.error("Error verifying mandates:", error);
          setResult("Error: " + error.message);
          } finally {
          setLoading(false);
      }
  };
	return (
		<main id="SmsAlertPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <Title title={$t('smsAlert')}   titleClass="text-lg font-bold text-primary" subTitleClass="text-500"      separator={false} />
                <div className="">
                    <div className="p-4 max-w-md mx-auto bg-white shadow-lg rounded-lg">
                        <h2 className="text-xl font-bold mb-4">
                        Send Alert for Pay by Date Range
                        </h2>
                        <div className="sm:col-12 lg:col-5 md:col-4 comp-grid" >
                            {/* FROM DATE */}
                            <Calendar
                            showIcon
                            showButtonBar
                            dateFormat="yy-mm-dd"
                            className="w-full mb-3"
                            value={dateFrom}
                            onChange={(e) => setDateFrom(e.value)} // ✅ FIX
                            placeholder={$t('Date From')}
                            />
                        </div>
                        <div className="sm:col-12 lg:col-5 md:col-4 comp-grid" >
                            {/* TO DATE */}
                            <Calendar
                            showIcon
                            showButtonBar
                            dateFormat="yy-mm-dd"
                            className="w-full mb-3"
                            value={dateTo}
                            onChange={(e) => setDateTo(e.value)} // ✅ FIX
                            placeholder={$t('Date To')}
                            />
                        </div>
                        <div className="sm:col-12 lg:col-5 md:col-4 comp-grid" >
                            <button
                            onClick={handleVerify}
                            disabled={loading}
                            className="bg-red-600 text-white px-4 py-2 rounded w-full hover:bg-blue-700"
                            >
                            {loading ? "Processing..." : "Send Alerts"}
                            </button>
                        </div>
                    </div>
                    {result && result.success && (
                    <div className="mt-6">
                        {/* Summary */}
                        <div className="mb-4 p-3 bg-green-50 border border-green-300 rounded">
                            <p className="font-semibold text-green-700">
                            {result.message}
                            </p>
                            <p>Total SMS Queued: <b>{result.count}</b></p>
                            <p>Template: <b>{result.data.templateName}</b></p>
                        </div>
                        {/* Table */}
                        <div className="overflow-x-auto">
                            <table className="min-w-full border border-gray-300 text-sm">
                                <thead className="bg-gray-100">
                                    <tr>
                                        <th className="border px-2 py-1">#</th>
                                        <th className="border px-2 py-1">Mobile</th>
                                        <th className="border px-2 py-1">Member</th>
                                        <th className="border px-2 py-1">Due</th>
                                        <th className="border px-2 py-1">Pay Date</th>
                                        <th className="border px-2 py-1">Loan A/C</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {result.data.messages.map((m, index) => (
                                    <tr key={index} className="hover:bg-gray-50">
                                        <td className="border px-2 py-1 text-center">
                                            {index + 1}
                                        </td>
                                        <td
                                            className={`border px-2 py-1 ${
                                            m.phone.trim() === "N/A"
                                            ? "text-red-600 font-semibold"
                                            : ""
                                            }`}
                                            >
                                            {m.phone}
                                        </td>
                                        <td className="border px-2 py-1">
                                            {m.variables.membername}
                                        </td>
                                        <td className="border px-2 py-1 text-right">
                                            ₹ {m.variables.credit}
                                        </td>
                                        <td className="border px-2 py-1 text-center">
                                            {m.variables.transactiondate}
                                        </td>
                                        <td className="border px-2 py-1">
                                            {m.variables.balance}
                                        </td>
                                    </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    )}
                </div>
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
